<button *ngIf="!useLinkButton"
        mat-raised-button
        color="warn"
        [disabled]="disabled"
        [ngClass]="ngClass"
        [routerLink]="routerLink"
>
  <mat-icon class="valign-middle">delete</mat-icon>
  Delete
</button>
<a *ngIf="useLinkButton && !disabled" [ngClass]="ngClass" [routerLink]="routerLink">
  <mat-icon class="valign-middle">delete</mat-icon>
</a>
<button class="btn btn-link m-0 p-0" [disabled]="disabled" *ngIf="useLinkButton && disabled" [ngClass]="ngClass">
  <mat-icon class="valign-middle">delete</mat-icon>
</button>
